import { ReactNode } from "react";
import { Card, CardProps, Typography } from "@xcorejs/ui";
import { Heading3 } from "design-system";
import { Box } from "@mui/joy";

export type HappyHoursIntroCardProps = {
  image: ReactNode;
  heading: ReactNode;
  text: ReactNode;
} & CardProps;

export const HappyHoursIntroCard = ({ heading, text, image }: HappyHoursIntroCardProps) => {
  return (
    <Card
      variant="elevated"
      maxWidth="initial"
      body={
        <Box width="100%" display="flex" flexDirection="column" alignItems="center" padding="2rem">
          {image}
          <Heading3 mt="2rem">{heading}</Heading3>
          <Typography textAlign="center">{text}</Typography>
        </Box>
      }
    />
  );
};
